export default "__VITE_ASSET__DRnk7IMR__"